import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useEffect } from "react";



import { AuthProvider, useAuth } from "./contexts/AuthContext";
import UnregisteredView from "./components/UnregisteredView";
import ScrollToTop from "./components/ScrollToTop";
import PerformanceMonitor from "./components/PerformanceMonitor";
import { applyFaviconForPath } from "./utils/favicon";

function FaviconSwitcher() {
  const location = useLocation();

  useEffect(() => {
    applyFaviconForPath(location.pathname);
  }, [location.pathname]);

  return null;
}

function AppContent() {
  const { isUnregisteredError, loading } = useAuth();



  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;

  if (isUnregisteredError) {
    return <UnregisteredView />;
  }

  return (
    <>
      <FaviconSwitcher />
      <AppRoutes />
      <PerformanceMonitor />
    </>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <ScrollToTop />
          <AppContent />
        </BrowserRouter>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
